import React, { useContext } from 'react';
import { RowContainer, Typography } from '../../../components/common';
import InstancesTable from '../../../components/common/instancesTable';
import { UserContext } from '../../../contexts/user';
import AgentDayRoutingProfileSummary from './agentDayRoutingProfileSummary';

const AgentDashboard = () => {
  const { instances, isLoading } = useContext(UserContext);

  return (
    <RowContainer>
		<div className="w-2/3 pr-6">
			<Typography className="pb-4" variant="heading1.1">Available Instances</Typography>
			<InstancesTable instances={instances()} isLoading={isLoading} />
		</div>
		<div className="w-1/3 pl-6">
			<Typography className="pb-4" variant="heading1.1">Daily Schedule</Typography>
			<AgentDayRoutingProfileSummary />
		</div>
    </RowContainer>
  );
};

export default AgentDashboard;
